import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  Form,
  Checkbox
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import Loader from '../Loader/Loader';
import api from '../../api';
import { GRANT_TYPE_PASSWORD } from '../../constants/users';
import './ConfirmAccount.css';
import WithRouter from '../Extensions/WithRouter';

class ConfirmAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordConfirmation: '',
      passwordError: '',
      passwordConfirmationError: '',
      serverErrors: [],
      isOpenEula: false,
      errorModalIsOpen: false,
      attentionModalIsOpen: false,
      isLoading: false,
      isCheckedAll: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmationChange = this.handlePasswordConfirmationChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeErrorModal = this.closeErrorModal.bind(this);
    this.closeAttentionModal = this.closeAttentionModal.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.resetErrors = this.resetErrors.bind(this);
    this.activateUser = this.activateUser.bind(this);
    this.getConfirmationToken = this.getConfirmationToken.bind(this);
    this.isPasswordReset = this.isPasswordReset.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  componentDidMount() {
    this.checkEula();
    if (this.passwordInput) {
      this.passwordInput.focus();
    }
  }

  handleConfirm(event) {
    if (event.key === 'Enter') {
      this.onSubmit();
    }
  }

  handleChange(e) {
    const item = e.target.name;
    const isChecked = e.target.checked;

    this.setState({
      [item]: isChecked,
    });
  }

  handleModal() {
    const {
      isCheckedAll,
    } = this.state;
    const token = this.getConfirmationToken();
    if (isCheckedAll) {
      const data = {
        confirmation_token: token,
        evaluation_agreement: true,
        eula: true,
        data_access_policy: true,
        authorization_and_release_for_promotion: true,
      };
      api.confirmEula(data)
        .then(() => {
          this.setState({
            isOpenEula: false,
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            errorModalIsOpen: true,
          });
        });
    } else {
      this.setState({
        attentionModalIsOpen: true,
      });
      return null;
    }
  }

  handlePasswordChange(e) {
    this.setState({
      password: e.target.value,
      passwordError: '',
    });
  }

  handlePasswordConfirmationChange(e) {
    this.setState({
      passwordConfirmation: e.target.value,
      passwordConfirmationError: '',
    });
  }

  onSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    if (!this.validateFields()) {
      return null;
    }

    const { password } = this.state;
    const { passwordConfirmation } = this.state;
    const token = this.getConfirmationToken();

    this.activateUser(password, passwordConfirmation, token, this.isPasswordReset());
  }

  getConfirmationToken() {
    const { searchParams } = this.props;
    const [URLSearchParams] = searchParams;
    if (this.isPasswordReset()) {
      return URLSearchParams.get('reset-password-token');
    }
    return URLSearchParams.get('confirmation-token');
  }

  isPasswordReset() {
    const { location } = this.props;
    const path = location.pathname ? location.pathname : location;
    return path === '/reset_password';
  }

  checkEula() {
    const token = this.getConfirmationToken();
    api.checkEula(token)
      .then((response) => {
        if (response.response.eula_required && response.response.eula_type === 'Early_Adapter') {
          this.setState({
            isOpenEula: true,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  activateUser(pass, passConfirmation, token, isReset) {
    const { password, } = this.state;
    const {
      state, location, t, navigate
    } = this.props;
    this.setState({
      isLoading: true,
    });
    api.activateUser(password, passConfirmation, token, isReset)
      .then((response) => {
        const data = {
          email: response.response.email,
          password,
          grant_type: GRANT_TYPE_PASSWORD,
        };

        api.getLogin(data)
          .then((loginResponse) => {
            state.user.setSession(loginResponse);
            if (location.pathname === '/reset_password') {
              this.access_token = loginResponse.access_token;
              api.getUserProfile(this.access_token).then((rsp) => {
                const res = rsp.response;
                state.user.setUserProfile(res);
                if (res.main_page === 'dashboard') {
                  navigate('/main', { replace: true });
                } else if (res.main_page === 'results') {
                  navigate('/results', { replace: true });
                } else {
                  navigate(`/results/${state.user.main_page}`, { replace: true });
                }
              });
            } else {
              navigate('/results', { replace: true });
            }
          })
          .catch(() => {
            navigate('/login', { replace: true });
          });
      })
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        let errorArray;
        if (o.error_description) {
          if (o.error_description.length !== 0) {
            errorArray = o.error_description.map((item, index) => {
              return {
                error: item,
                id: index,
              };
            });
            this.setState({
              isLoading: false,
              serverErrors: errorArray,
            });
          }
        } else {
          this.setState({
            isLoading: false,
            serverErrors: t('modal.new_scan.message.warn_unknown'),
          });
        }
      });
  }

  closeModal() {
    this.setState({
      isOpenEula: false,
    });
  }

  closeErrorModal() {
    const { navigate } = this.props;
    this.setState({
      errorModalIsOpen: false,
      isOpenEula: false,
    });
    navigate('/login', { replace: true });
  }

  closeAttentionModal() {
    this.setState({
      attentionModalIsOpen: false,
    });
  }

  resetErrors() {
    this.setState({
      serverErrors: [],
    });
  }

  validateFields() {
    const { t } = this.props;
    const {
      password,
      passwordConfirmation,
    } = this.state;
    const validation = {
      password: true,
      passwordConfirmation: true,
    };

    if (password.trim().length === 0) {
      this.setState({
        passwordError: t('modal.error.empty_password'),
      });
      validation.password = false;
      return;
    } if (!this.checkPassword(password)) {
      this.setState({
        passwordError: t('modal.error.error_char_password'),
      });
      validation.password = false;
      return;
    }
    validation.password = true;

    if (password !== passwordConfirmation) {
      this.setState({
        passwordConfirmationError: t('modal.error.error_match_confirm_password'),
      });
      validation.passwordConfirmation = false;
      return;
    }
    validation.passwordConfirmation = true;

    return (
      validation.password
      && validation.passwordConfirmation
    );

  }

  checkPassword(value) {
    let char_type = 0;
    if (/[A-Z]/.test(value) || /[a-z]/.test(value)) {
      char_type += 1;
    }
    if (/[0-9]/.test(value)) {
      char_type += 1;
    }
    if (/[~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./]/gi.test(value)) {
      char_type += 1;
    }
    return !(char_type < 3 || value.length < 8 || value.length > 72);
  }

  render() {
    const {
      password,
      passwordError,
      passwordConfirmation,
      passwordConfirmationError,
      serverErrors,
      isCheckedAll,
      isLoading,
      isOpenEula,
      errorModalIsOpen,
      attentionModalIsOpen,
    } = this.state;
    const { t } = this.props;
    const passErrorClass = passwordError !== '' ? 'show' : '';
    const confirmErrorClass = passwordConfirmationError !== '' ? 'show' : '';
    const cssSelected = isCheckedAll ? 'show' : 'hidden';

    if (isLoading) {
      return <Loader />;
    }

    return (
      <div className="login_contents">
        <div className="login_box box">
          <p className="label">
            {t('login.menu.new_password')}
          </p>
          <input
            type="password"
            className="email"
            name="pass"
            placeholder={t('login.menu.password')}
            value={password}
            onChange={this.handlePasswordChange}
            onKeyPress={this.handleConfirm}
            ref={(ref) => { this.passwordInput = ref; }}
          />
          <div className={`error ${passErrorClass}`}>{passwordError}</div>
          <p className="label">
            {t('modal.title.password_confirmation')}
          </p>
          <input
            type="password"
            className={t('login.menu.password')}
            name="pass-confirmation"
            value={passwordConfirmation}
            placeholder="Password Confirmation"
            onChange={this.handlePasswordConfirmationChange}
            onKeyPress={this.handleConfirm}
          />
          <div className={`error ${confirmErrorClass}`}>{passwordConfirmationError}</div>
        </div>
        <div className="error-full">
          {serverErrors.map((item) => {
            return (<div key={item.id}>{item.error}</div>);
          })}
        </div>
        <div className="button_box box">
          <a
            onClick={this.onSubmit}
            onKeyDown={this.onSubmit}
            className="login_button"
          >
            {
              this.isPasswordReset() ? t('login.menu.reset_password') : t('login.menu.activate_ur_account')
            }
          </a>
        </div>
        <Modal
          className="eula"
          open={isOpenEula}
          onClose={this.closeModal}
          closeOnDimmerClick={false}
          closeOnEscape={false}
        >
          <ModalHeader>
            <h2>Welcome to Clarity Evaluation</h2>
            <h4>Please read the following terms and agree to begin evaluation</h4>
          </ModalHeader>
          <ModalContent>
            <Form>
              <Form.Field>
                <h4>Evaluation Agreement</h4>
                <div className="terms_box long">
                  <div className="article">
                    <h3 className="article_title">INSIGNARY CLARITY EVALUATION AGREEMENT</h3>
                    <p className="article_text">
                      This Insignary Clarity Evaluation Agreement (this &ldquo;
                      <strong>Agreement</strong>
                      &rdquo;) governs the relationship between you (&ldquo;
                      <strong>Participant</strong>
                      &rdquo;) and Insignary Inc. (&ldquo;
                      <strong>Insignary</strong>
                      &rdquo;) and provides the relevant terms and conditions regarding your participation in the evaluation of Insignary Clarity, software in Insignary Clarity, and cloud service of Insignary Clarity (&ldquo;
                      <strong>Insignary Clarity</strong>
                      &rdquo;).
                    </p>
                    <p>&nbsp;</p>
                    <h3 className="article_subTitle">Service</h3>
                    <p className="article_text">During the evaluation period set by Insignary from time to time for its newly developed features and/or functions of Insignary Clarity, Insignary will provide:</p>
                    <ul>
                      <li>Early access to the newly developed features and/or functions of Insignary Clarity and Insignary Clarity databases;</li>
                      <li>Support from Insignary&rsquo;s key engineers for using Insignary Clarity;</li>
                    </ul>
                    <p>&nbsp;</p>
                    <h3 className="article_subTitle">Cooperation</h3>
                    <p className="article_text">Participant hereby agrees to provide to Insignary, if requested, feedback about participating and using the Insignary Clarity, and Insignary and Participant hereby agree to cooperate in iteration of scanning, reporting and user interface of Insignary Clarity, with Insignary&rsquo;s undertaking to provide engineering resources to address feedback provided by Participant from time to time.</p>
                    <p>&nbsp;</p>
                    <h3 className="article_subTitle">Evaluation Period</h3>
                    <p className="article_text">
                      <span style={{ color: '#C00000' }}>
                        The evaluation period granted to Participant hereunder is fourteen (14) days unless set otherwise by Insignary at its sole discretion (&ldquo;
                        <strong>Evaluation Period</strong>
                        &rdquo;).
                        {' '}
                      </span>
                      {' '}
                      Further terms of Insignary Clarity access are governed by the separate End User License Agreement (EULA) that shall be incorporated into this Agreement by reference hereof.
                    </p>
                    <p>&nbsp;</p>
                    <h3 className="article_subTitle">Cost</h3>
                    <p className="article_text">The cost of access to Insignary Clarity during the Evaluation Period is free.</p>
                    <p>&nbsp;</p>
                    <h3 className="article_subTitle">Miscellaneous</h3>
                    <p className="article_text">If any provision of this Agreement is held to be unenforceable, the enforceability of the remaining provisions shall not be affected, and such provision held unenforceable shall be construed and enforced to the maximum extent permitted by law as if such provision had been originally incorporated herein as so modified.</p>
                    <p className="article_text"><span style={{ color: '#C00000' }}>Insignary Clarity provided pursuant to this Agreement shall be provided &ldquo;AS IS&rdquo;, and as such, Insignary specifically disclaims any warranty, express and implied, as to the accuracy, completeness, fitness for any purpose or merchantability of any part thereof, unless otherwise specifically set forth.</span></p>
                    <p className="article_text">
                      Any claim, controversy or dispute arising under or relating to this Agreement and interpretation of this Agreement shall be governed by the laws of the
                      {' '}
                      <span style={{ color: '#C00000' }}>Republic of Korea</span>
                      . Insignary and Participant hereby agree to irrevocably submit to the exclusive jurisdiction of the
                      {' '}
                      <span style={{ color: '#C00000' }}>Seoul Central District Court</span>
                      {' '}
                      any claim, controversy or dispute arising out of or in connection with this Agreement, and waive any objections that venue is improper.
                    </p>
                    <p>&nbsp;</p>
                    <h3 className="article_subTitle">Contact Information</h3>
                    <p className="article_text">Suite 2106 Trade Tower 511 Yeongdong-daero</p>
                    <p className="article_text">Gangnam-gu Seoul 06164 Republic of Korea</p>
                    <p className="article_text">Telephone: +82-2-547-7006</p>
                    <p className="article_text">Email: sales@insignary.com</p>
                  </div>
                </div>
              </Form.Field>
              <Form.Field>
                <h4>EULA</h4>
                <div className="terms_box long">
                  <div className="article">
                    <h3 className="article_title">INSIGNARY CLARITY END USER LICENSE AGREEMENT</h3>
                    <p className="article_text" style={{ marginBottom: '12px' }}>
                      PLEASE READ THIS END USER LICENSE AGREEMENT CAREFULLY BEFORE USING ANY SOFTWARE OR SERVICE PROVIDED BY INSIGNARY INC. (&ldquo;
                      <strong>INSIGNARY</strong>
                      &rdquo;) INCLUDING WITHOUT LIMIT INSIGNARY CLARITY, SOFTWARES IN INSIGNARY CLARITY AND CLOUD SERVICE BY INSIGNARY (&ldquo;
                      <strong>INSIGNARY SOFTWARE</strong>
                      &rdquo;).
                      {' '}
                      <span style={{ color: '#C00000' }}>
                        BY USING INSIGNARY SOFTWARE, YOU EXPRESSLY GIVE YOUR CONSENT TO AND ACCEPTANCE OF THIS END USER LICENSE AGREEMENT (THIS &ldquo;
                        <strong>AGREEMENT</strong>
                        &rdquo;) AND ACKNOWLEDGE YOU HAVE READ AND UNDERSTOOD THE TERMS OF THIS AGREEMENT.
                      </span>
                      {' '}
                      IF YOU DO NOT ACCEPT OR AGREE TO ANY OF THE TERMS OF THIS AGREEMENT, THEN YOU SHOULD NOT USE THE INSIGNARY SOFTWARE. THIS AGREEMENT DOES NOT PROVIDE YOU WITH ANY RIGHTS TO INSIGNARY SERVICES SUCH AS SOFTWARE MAINTENANCE, UPGRADES OR SUPPORT. PLEASE REFER TO YOUR SERVICE OR SUBSCRIPTION AGREEMENT THAT YOU MAY HAVE ENTERED INTO WITH INSIGNARY OR OTHER AUTHORIZED INSIGNARY SERVICE PROVIDERS REGARDING INSIGNARY SERVICES AND RELAVANT TERMS. AN INDIVIDUAL USING INSIGNARY SOFTWARE ON BEHALF OF OR FOR AN ENTITY OR OTHERWISE ACTING ON BEHALF OF AN ENTITY REPRESENTS THAT HE OR SHE HAS THE AUTHORITY TO ENTER INTO THIS AGREEMENT ON BEHALF OF THAT ENTITY.
                    </p>
                    <p className="article_text">
                      This Agreement governs the use of any of the versions of Insignary Clarity, certain other Insignary software applications or cloud services that include or refer to this Agreement or Insignary Clarity, and any related updates, source code, appearance, structure and organization (the &ldquo;
                      <strong>Programs</strong>
                      &rdquo;), regardless of the delivery mechanism or medium.
                    </p>
                    <h3 className="article_subTitle">1.License Grant</h3>
                    <p className="article_text">
                      Subject to the following terms and conditions, Insignary grants to you a
                      {' '}
                      <span style={{ color: '#C00000' }}>non-exclusive</span>
                      {' '}
                      license to use an Insignary Clarity server (which includes multiple software components) pursuant to the respective license applicable to each software component for a period set forth in the relevant agreement executed between you and Insignary. The Agreement for each software component is located in the software component&apos;s source code. This Agreement pertains solely to the Programs and does not limit your rights under, or grant you rights that supersede the license terms of any particular component.
                    </p>
                    <h3 className="article_subTitle">2.Intellectual Property Rights.</h3>
                    <p className="article_text">
                      The Programs and each of their components are owned by Insignary and other licensors, if any, and are protected under copyright law and/or other laws as applicable. Title to the Programs and any component, or to any copy, modification, or merged portion shall remain with Insignary and other licensors, if any, subject to the applicable license. The word &ldquo;Insignary&rdquo;, its logo and programs together with each of their components are Insignary&rsquo;s properties, whether intellectual or otherwise, including without limit patents and trademarks in the Republic of Korea and other countries.
                      {' '}
                      <span style={{ color: '#C00000' }}>This Agreement does not permit you to distribute the Programs or any of their components using Insignary&apos;s properties, regardless of whether the copy has been modified. You may make a commercial redistribution of the Programs or any of their components only if permitted under a separate written agreement with Insignary authorizing such commercial redistribution.</span>
                    </p>
                    <h3 className="article_subTitle">3.No Warranty</h3>
                    <p className="article_text">
                      Except as specifically stated in this Section 3, a separate agreement with Insignary, or a license for a particular component, to the extent permitted under applicable law,
                      {' '}
                      <span style={{ color: '#C00000' }}>the Programs and their components are provided and licensed &ldquo;as is&rdquo; without warranty of any kind, expressed or implied, including without limit the implied warranties of merchantability, non-infringement or fitness for a particular purpose. Neither Insignary nor its affiliates warrant that the functions contained in the Programs or their components will meet your requirements or that the operation of the Programs or their components will be entirely error free, appear or perform precisely as described in the accompanying documentation, or comply with regulatory requirements.</span>
                    </p>
                    <h3 className="article_subTitle">4.Limitation of Liability.</h3>
                    <p className="article_text">
                      To the extent permitted by and subject to applicable law,
                      {' '}
                      <span style={{ color: '#C00000' }}>under no circumstances shall Insignary, any of its affiliates, any Insignary authorized distributor, or the licensor of any component provided to you under this Agreement be liable to you for any indirect, incidental, special or consequential damages, including without limit lost profits, lost savings, loss of good will, work stoppage, data loss, or computer failure or malfunction arising out of or in connection with the use or inability to use the Programs or any component, even if Insignary, its affiliates, an authorized distributor and/or licensor has been advised of the possibility of such damages. In no event shall Insignary, any of its affiliates, any Insignary authorized distributor, or the licensor of any component provided to you under this Agreement be liable for more than the amount that you paid to Insignary for the defective media under this Agreement.</span>
                    </p>
                    <h3 className="article_subTitle">5.Limitation of Assignment.</h3>
                    <p className="article_text"><span style={{ color: '#FF0000' }}>You may not, without a prior written consent of Insignary, assign, delegate, pledge, or otherwise transfer this Agreement, or any of your rights or obligations under this Agreement, or any of Insignary&rsquo;s properties described in Section 2, to any party, whether voluntarily or by operation of law, including by way of sale of assets, merger or consolidation. Insignary may assign this Agreement to its affiliate or subsidiary by giving a prior written notice thereof.</span></p>
                    <h3 className="article_subTitle">6.Export Control.</h3>
                    <p className="article_text">
                      You acknowledge and understand that the laws of many countries including without limit the Republic of Korea and United States provide for export control and related prescriptions. Additionally,
                      {' '}
                      <span style={{ color: '#C00000' }}>you represent and warrant that as the Programs and their components may be subject to applicable local and foreign export control laws, you will be liable to ensure that your use of the Programs or any of their components is in compliance with applicable export control laws.</span>
                      {' '}
                      With regard to such export control laws, you particularly represent and warrant that you (a) understand that the Programs and their components may be subject to export controls under the relevant laws including without limit U.S. Export Administration Regulations (&ldquo;
                      <strong>EAR</strong>
                      &rdquo;); (b) are not located in a prohibited destination country under the EAR or sanctions regulations, whether national or international (such as Cuba, Iran, Iraq, North Korea, Sudan and Syria, subject to change as designated by the relevant authorities); (c) will not export, re-export, or transfer the Programs or any of their components to any prohibited destination or persons or entities listed on any list maintained by national authorities; (d) will not use or transfer the Programs or their components for use in connection with any nuclear, chemical or biological weapons, missile technology, or military end-uses where prohibited by an applicable arms embargo, unless authorized by the relevant government agency; and (e) understand that countries including without limit the Republic of Korea and United States may restrict the import, use, or export of encryption products (which may include the Programs and their components) and agree that you shall be solely responsible for compliance with any such import, use, or export restrictions. Further, you agree that you will not submit the Programs or their components to any government agency for licensing consideration or other regulatory approval without the prior written consent of Insignary. You acknowledge that the delivery of the Programs or their components (including patches, fixes, updates, upgrades and new versions) may be subject to the prior obtaining of export and/or import authorizations from the competent authorities and that this process may considerably delay or prevent the delivery and/or impact Insignary&apos;s ability to provide maintenance and support.
                    </p>
                    <h3 className="article_subTitle">7.General Provisions.</h3>
                    <p className="article_text">
                      If any provision of this Agreement is held to be illegal or unenforceable, the legality or enforceability of the remaining provisions shall not be affected. The rights and obligations of the parties to this Agreement shall not be governed by the United Nations Convention on the International Sale of Goods. Any claim, controversy or dispute arising out of or in connection this Agreement shall be
                      {' '}
                      <span style={{ color: '#C00000' }}>governed by the laws of the Republic of Korea</span>
                      , without regard to any conflict of laws provisions. In case that any claim, controversy or dispute arising out of or in connection this Agreement is not resolved amicably through mutual discussion, such unresolved claim, controversy or dispute shall be submitted to the exclusive jurisdiction of
                      {' '}
                      <span style={{ color: '#C00000' }}>Seoul Central District Court for resolution</span>
                      .
                    </p>
                  </div>
                </div>
              </Form.Field>
              <Form.Field>
                <h4>Data Access Policy</h4>
                <div className="terms_box shorts">
                  <div className="article">
                    <h3 className="article_title">INSIGNARY CLARITY DATA ACCESS POLICY</h3>
                    <p className="article_text">
                      While you are using the service provided by Insingary Inc. (&ldquo;
                      <strong>Insignary</strong>
                      &rdquo;), including but not limited to Insignary Clarity, Insignary may collect and use technical data and related information, including but not limited to the binary files you uploaded for your use of Insignary Clarity and the scanning results generated by Insignary Clarity. Insignary may use such data and information, so long as they are in a form that does not personally identify you, to improve its products or to provide services or technologies to you.
                    </p>
                  </div>
                </div>
              </Form.Field>
            </Form>
          </ModalContent>
          <div className="terms_chk_all">
            <Checkbox
              label="I agreed to all terms below"
              value="isCheckedAll"
              name="isCheckedAll"
              id="isCheckedAll"
              checked={isCheckedAll}
              onChange={this.handleChange}
            />
          </div>
          <div className="button_wrap">
            <a onClick={this.closeErrorModal} onKeyDown={this.closeErrorModal} className="left_button">{t('modal.button.cancel')}</a>
            <a onClick={this.handleModal} onKeyDown={this.handleModal} disabled={!isCheckedAll} className={`right_button ${cssSelected}`}>{t('modal.button.submit')}</a>
          </div>
        </Modal>
        <Modal
          open={errorModalIsOpen}
          onClose={this.closeErrorModal}
          className="modal"
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">
                  {t('modal.title.attention')}
                </h2>
                <p className="text">
                  {t('login.message.invalid_token')}
                </p>
                <div className="button_wrap">
                  <a onClick={this.closeErrorModal} onKeyDown={this.closeErrorModal} className="center_button">{t('modal.button.ok')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={attentionModalIsOpen}
          onClose={this.closeAttentionModal}
          className="modal"
        >
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">
                  {t('modal.title.attention')}
                </h2>
                <p className="text">
                  {t('login.message.check_the_box')}
                </p>
                <div className="button_wrap">
                  <a onClick={this.closeAttentionModal} onKeyDown={this.closeAttentionModal} className="center_button">{t('modal.button.ok')}</a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(ConfirmAccount))));
